import { useEffect } from "react";
import { AssistantRuntimeProvider } from "@assistant-ui/react";
import { useAppDispatch } from "../../store/hooks";
import { setDrawerOpen } from "../../store/slices/copilotSlice";
import { useCopilotRuntime } from "../../hooks/useCopilotRuntime";
import { CopilotPanel } from "./CopilotPanel";

/** Root copilot drawer: owns the runtime and the Escape-to-close binding. */
export function CopilotDrawer() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") dispatch(setDrawerOpen(false));
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [dispatch]);

  const runtime = useCopilotRuntime();

  return (
    <div
      className="relative h-full overflow-hidden"
      role="dialog"
      aria-label="AI Copilot"
      aria-modal="false"
    >
      <AssistantRuntimeProvider runtime={runtime}>
        <CopilotPanel onClose={() => dispatch(setDrawerOpen(false))} />
      </AssistantRuntimeProvider>
    </div>
  );
}
